import { ImageOff } from 'lucide-react'
import { formatarReais } from '@du/shared'
import { cn } from '../lib/cn.js'
import { Badge } from './Badge.js'
import { Icone } from './Icone.js'
import { PriceSeal } from './PriceSeal.js'

/**
 * Guia, sobre fotografia: "Lanche em primeiro plano, bem de perto, com luz
 * quente. Prefira fotos reais da casa. Bebidas sempre recortadas, sem fundo."
 *
 * Daí duas decisões do componente:
 *  - a foto ocupa o topo inteiro, recortada em object-fit: cover, para o
 *    lanche chegar perto mesmo quando a foto vem larga;
 *  - variante "recortada" (bebidas) usa contain sobre fundo da superfície,
 *    porque PNG sem fundo em cover fica cortado no meio da lata.
 * Sem foto, cai num bloco laranja com o nome — nunca uma ilustração genérica,
 * que o guia proíbe.
 */
export type ProductCardProps = {
  nome: string
  precoCents: number
  ingredientes?: string | null | undefined
  fotoUrl?: string | null | undefined
  /** Bebida e afins: PNG sem fundo, exibido inteiro. */
  recortada?: boolean | undefined
  esgotado?: boolean | undefined
  destaque?: boolean | undefined
  selo?: boolean | undefined
  onClick?: () => void | undefined
  className?: string | undefined
}

export function ProductCard({
  nome,
  precoCents,
  ingredientes,
  fotoUrl,
  recortada,
  esgotado,
  destaque,
  selo,
  onClick,
  className,
}: ProductCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={esgotado}
      aria-label={`${nome}, ${formatarReais(precoCents)}${esgotado ? ', esgotado' : ''}`}
      className={cn(
        'du-cartao',
        destaque && 'du-cartao--destaque',
        esgotado && 'du-cartao--esgotado',
        className,
      )}
    >
      <span className={cn('du-cartao__foto', recortada && 'du-cartao__foto--recortada')}>
        {fotoUrl ? (
          <img src={fotoUrl} alt="" loading="lazy" decoding="async" />
        ) : (
          <span className="du-cartao__semfoto">
            <Icone de={ImageOff} tamanho={28} cor="preto" />
            <span>{nome}</span>
          </span>
        )}
        {selo ? <PriceSeal precoCents={precoCents} tamanho="sm" className="du-cartao__selo" /> : null}
        {esgotado ? (
          <span className="du-cartao__tarja">
            <Badge tom="erro">ESGOTADO</Badge>
          </span>
        ) : null}
      </span>

      <span className="du-cartao__corpo">
        <span className="du-cartao__nome">{nome}</span>
        {ingredientes ? <span className="du-cartao__ingredientes">{ingredientes}</span> : null}
        {!selo ? <span className="du-cartao__preco">{formatarReais(precoCents)}</span> : null}
      </span>
    </button>
  )
}
